module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "py-0 padding-0",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [(_vm.isAdmin !== true) ? _c('v-flex', [_c('div', [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Contact Admin")])])])]) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.isAdmin === true) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title primary--text pa-3"
  }, [_vm._v("\n        Search Employee\n      ")]), _vm._v(" "), _c('v-form', {
    ref: "sForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchEmployee()
      }
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mx-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employee Name",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lSearch.emp_name),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "emp_name", $$v)
      },
      expression: "lSearch.emp_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Designation",
      "hide-details": "",
      "maxlength": "35"
    },
    model: {
      value: (_vm.lSearch.emp_desig),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "emp_desig", $$v)
      },
      expression: "lSearch.emp_desig"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employee Id",
      "hide-details": "",
      "maxlength": "6"
    },
    model: {
      value: (_vm.lSearch.vendor_emp_id),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "vendor_emp_id", $$v)
      },
      expression: "lSearch.vendor_emp_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "AADHAR No.",
      "hide-details": "",
      "maxlength": "20"
    },
    model: {
      value: (_vm.lSearch.aadhar_no),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "aadhar_no", $$v)
      },
      expression: "lSearch.aadhar_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("search")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.empList.length > 0) ? _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": "",
      "grid-list-md": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "title primary--text pa-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("Search Result (" + _vm._s(_vm.empList.length) + " Records)")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show all columns"
    },
    model: {
      value: (_vm.showAllColumns),
      callback: function($$v) {
        _vm.showAllColumns = $$v
      },
      expression: "showAllColumns"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.showAllColumns === true ? _vm.allColumnsHeader : _vm.emp,
      "items": _vm.empList,
      "title": "Employee List",
      "landscape": true,
      "fontsize": _vm.showAllColumns === true ? 6 : 9,
      "cellpadding": _vm.showAllColumns === true ? 0.25 : 1
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? (_vm.showAllColumns === true ? _vm.allColumnsHeader : _vm.emp) : _vm.empSm,
      "items": _vm.empList,
      "hide-default-footer": "",
      "disable-pagination": "",
      "sort-by": ['emp_name', 'vendor_emp_id'],
      "multi-sort": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditEmp(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.emp_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_emp_id))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.emp_phone || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.emp_desig || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.act_proj_list || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.comp_proj_list || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emp_email || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emp_adr || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.city || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.pincode || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emergency_contact || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emergency_phone || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.blood_group || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.known_health_issue || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.date_of_birth) || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.date_of_joining)))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.years_exp || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.gender || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.aadhar_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.marital_status || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.official_number || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_id_verified ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_address_verified ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_police_verif_done ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_pf_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.pf_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.uan || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_esi_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.esi_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_gmc_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.gmc_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_gpa_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.gpa_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_sub_vendor_emp ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.pan || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_acc_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_ifsc_code || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_name || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_branch_name || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.payroll_cat || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.date_of_relieved ? _vm.handy.formatDate(props.item.date_of_relieved) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.status_reason || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.last_working_date ? _vm.handy.formatDate(props.item.last_working_date) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.last_updated_on) || '-'))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.emp_status))])])]
      }
    }], null, false, 1685531695)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.isAdmin === true) ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:20px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    style: ('position:fixed; top:55px; right:10px;'),
    attrs: {
      "dark": "",
      "fab": "",
      "small": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareEmpTimeline($event)
      }
    }
  }, [_c('v-icon', [_vm._v("format_list_bulleted_add")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "eForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveEmployee(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + ' Employee') + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.isDupEmp) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "warning",
      "value": true
    }
  }, [_vm._v("\n                  Employee with similar details found in records. Please choose override and save again if it is not duplicate. "), _c('br'), _vm._v(" "), _c('v-data-table', {
    staticClass: "mt-2",
    attrs: {
      "headers": _vm.dupEmp,
      "items": _vm.dupEmpList,
      "hide-default-footer": "",
      "disable-pagination": "",
      "mobile-breakpoint": 0,
      "dark": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.emp_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_emp_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.aadhar_no || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.act_proj_list || '-'))])])]
      }
    }], null, false, 3568783435)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "text-center": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Override",
      "hide-details": ""
    },
    model: {
      value: (_vm.dupOverride),
      callback: function($$v) {
        _vm.dupOverride = $$v
      },
      expression: "dupOverride"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "hide-details": "",
      "mandatory": false,
      "row": ""
    },
    model: {
      value: (_vm.empType),
      callback: function($$v) {
        _vm.empType = $$v
      },
      expression: "empType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Own Employee",
      "value": "oe"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": _vm.lAction === 'create' ? 'success' : 'warning',
      "value": true
    }
  }, [_c('v-layout', {
    attrs: {
      "pa-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_vm._v("\n                Employee Id " + _vm._s(_vm.lAction === 'create' ? 'will be' : 'is') + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [(!_vm.nextEmpEdited) ? _c('strong', [_vm._v(_vm._s(_vm.lAction === 'create' ? _vm.lEmp.next_vendor_emp_id : _vm.lEmp.vendor_emp_id))]) : _vm._e(), _vm._v(" "), (_vm.nextEmpEdited && _vm.lAction === 'create') ? _c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "10",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.lEmp.next_vendor_emp_id),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "next_vendor_emp_id", $$v)
      },
      expression: "lEmp.next_vendor_emp_id"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nextEmpEdited && _vm.lAction === 'update') ? _c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "10",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.lEmp.vendor_emp_id),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "vendor_emp_id", $$v)
      },
      expression: "lEmp.vendor_emp_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.nextEmpEdited = !_vm.nextEmpEdited
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employee Name [As Per Aadhar]",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.emp_name),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_name", $$v)
      },
      expression: "lEmp.emp_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Gender",
      "items": ['Male', 'Female'],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lEmp.gender),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "gender", $$v)
      },
      expression: "lEmp.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Designation",
      "items": _vm.empDesig,
      "item-text": "emp_desig",
      "item-value": "emp_desig_id",
      "rules": [_vm.rules.required],
      "return-object": ""
    },
    model: {
      value: (_vm.lEmp.emp_desig_pair),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_desig_pair", $$v)
      },
      expression: "lEmp.emp_desig_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Staff Role",
      "items": _vm.empRole,
      "item-text": "staff_role",
      "item-value": "staff_role_id",
      "rules": [_vm.rules.required],
      "return-object": ""
    },
    model: {
      value: (_vm.lEmp.staff_role_pair),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "staff_role_pair", $$v)
      },
      expression: "lEmp.staff_role_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgjoinDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lEmp.date_of_joining
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_joining", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_joining", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": "Date Of Joining",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "rules": [_vm.rules.required]
          },
          slot: "activator",
          model: {
            value: (_vm.lEmp.date_of_joining),
            callback: function($$v) {
              _vm.$set(_vm.lEmp, "date_of_joining", $$v)
            },
            expression: "lEmp.date_of_joining"
          }
        }, on))]
      }
    }], null, false, 1045578302),
    model: {
      value: (_vm.dlgjoinDt),
      callback: function($$v) {
        _vm.dlgjoinDt = $$v
      },
      expression: "dlgjoinDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    model: {
      value: (_vm.lEmp.date_of_joining),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "date_of_joining", $$v)
      },
      expression: "lEmp.date_of_joining"
    }
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgjoinDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgjoinDt.save(_vm.lEmp.date_of_joining)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "AADHAR No.",
      "rules": [_vm.rules.required],
      "required": "",
      "minlength": "12",
      "maxlength": "12"
    },
    model: {
      value: (_vm.lEmp.aadhar_no),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "aadhar_no", $$v)
      },
      expression: "lEmp.aadhar_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lEmp.date_of_birth
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_birth", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_birth", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": "Date Of Birth [As Per Aadhar]",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "rules": [_vm.rules.required]
          },
          slot: "activator",
          model: {
            value: (_vm.lEmp.date_of_birth),
            callback: function($$v) {
              _vm.$set(_vm.lEmp, "date_of_birth", $$v)
            },
            expression: "lEmp.date_of_birth"
          }
        }, on))]
      }
    }], null, false, 3917478194),
    model: {
      value: (_vm.dlgDt),
      callback: function($$v) {
        _vm.dlgDt = $$v
      },
      expression: "dlgDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        return _vm.calculateAge(_vm.lEmp.date_of_birth)
      }
    },
    model: {
      value: (_vm.lEmp.date_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "date_of_birth", $$v)
      },
      expression: "lEmp.date_of_birth"
    }
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgDt.save(_vm.lEmp.date_of_birth)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Age",
      "readonly": ""
    },
    model: {
      value: (_vm.lEmp.years_exp),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "years_exp", $$v)
      },
      expression: "lEmp.years_exp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Marital Status",
      "items": ['Single', 'Married', 'Widowed', 'Separated', 'Divorced'],
      "required": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lEmp.marital_status),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "marital_status", $$v)
      },
      expression: "lEmp.marital_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Official Number",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lEmp.official_number),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "official_number", $$v)
      },
      expression: "lEmp.official_number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_c('v-layout', [_c('v-card-title', [_vm._v("\n        Personal Information\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "rules": [_vm.rules.required],
      "maxlength": "100"
    },
    model: {
      value: (_vm.lEmp.emp_adr),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_adr", $$v)
      },
      expression: "lEmp.emp_adr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "rules": [_vm.rules.required],
      "maxlength": "25"
    },
    model: {
      value: (_vm.lEmp.city),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "city", $$v)
      },
      expression: "lEmp.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "PIN Code",
      "rules": [_vm.rules.required],
      "maxlength": "10",
      "type": "number"
    },
    model: {
      value: (_vm.lEmp.pin_code),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "pin_code", $$v)
      },
      expression: "lEmp.pin_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lEmp.emp_phone),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_phone", $$v)
      },
      expression: "lEmp.emp_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.emp_email),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_email", $$v)
      },
      expression: "lEmp.emp_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Emergency Contact")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lEmp.emergency_phone),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emergency_phone", $$v)
      },
      expression: "lEmp.emergency_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Contact Person",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.emergency_contact),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emergency_contact", $$v)
      },
      expression: "lEmp.emergency_contact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Blood Group",
      "hide-details": "",
      "maxlength": "5"
    },
    model: {
      value: (_vm.lEmp.blood_group),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "blood_group", $$v)
      },
      expression: "lEmp.blood_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Health Issue Known",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.known_health_issue),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "known_health_issue", $$v)
      },
      expression: "lEmp.known_health_issue"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_c('v-layout', [_c('v-card-title', [_vm._v("\n        Payroll Information\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Bank Account Details")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Account Number",
      "rules": [_vm.rules.required],
      "maxlength": "25"
    },
    model: {
      value: (_vm.lEmp.bank_acc_no),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_acc_no", $$v)
      },
      expression: "lEmp.bank_acc_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank IFSC Code",
      "rules": [_vm.rules.required],
      "maxlength": "15"
    },
    model: {
      value: (_vm.lEmp.bank_ifsc_code),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_ifsc_code", $$v)
      },
      expression: "lEmp.bank_ifsc_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Name",
      "rules": [_vm.rules.required],
      "maxlength": "40"
    },
    model: {
      value: (_vm.lEmp.bank_name),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_name", $$v)
      },
      expression: "lEmp.bank_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Branch Name",
      "rules": [_vm.rules.required],
      "maxlength": "100"
    },
    model: {
      value: (_vm.lEmp.bank_branch_name),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_branch_name", $$v)
      },
      expression: "lEmp.bank_branch_name"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "title font-weight:bold"
        }, [_vm._v("Documents")])]
      },
      proxy: true
    }], null, false, 1035742485)
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "my-notice"
  }, [_vm._v("\n              Must upload Aadhar card and Bank Passbook\n            ")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.empHeader,
      "items": _vm.lEmpDetails,
      "hide-default-footer": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.emp_doc_type))]), _vm._v(" "), _c('td', {
          class: props.item.files.length > 0 ? 'pt-2' : ''
        }, _vm._l((props.item.files), function(file, i) {
          return _c('span', {
            key: i
          }, [(file.is_selected) ? _c('span', [_c('v-chip', {
            staticClass: "mb-2",
            attrs: {
              "small": "",
              "close": ""
            },
            model: {
              value: (file.is_selected),
              callback: function($$v) {
                _vm.$set(file, "is_selected", $$v)
              },
              expression: "file.is_selected"
            }
          }, [_vm._v("\n                        " + _vm._s(file.file_name) + "\n                        "), _c('a', {
            staticStyle: {
              "text-decoration": "none"
            },
            attrs: {
              "href": _vm.handy.loadImg(file.file_url),
              "download": ""
            }
          }, [_c('v-btn', {
            staticClass: "mr-0 grey lighten-2 black--text text--lighten-4 ml-2",
            attrs: {
              "small": "",
              "icon": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "25px"
            }
          }, [_vm._v("download")])], 1)], 1)]), _c('br')], 1) : _vm._e()])
        }), 0), _vm._v(" "), _c('td', {
          staticClass: "pl-2 pr-0"
        }, [_c('input', {
          ref: "fileInput",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
            "multiple": ""
          },
          on: {
            "change": function($event) {
              return _vm.loadFilesFromFileBrowser()
            }
          }
        }), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.pickFile(props.item.emp_doc_type_id)
            }
          }
        }, [_c('v-icon', [_vm._v("upload")])], 1)], 1)])]
      }
    }], null, false, 2770496048)
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteEmp(_vm.lEmp)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": !_vm.isFileAdded
    },
    on: {
      "click": function($event) {
        return _vm.deployeIntoProject()
      }
    }
  }, [_vm._v("Deploy")]) : _vm._e(), _vm._v(" "), (_vm.lAction !== 'create') ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("save")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showInsertUpdateDocType),
      callback: function($$v) {
        _vm.showInsertUpdateDocType = $$v
      },
      expression: "showInsertUpdateDocType"
    }
  }, [_c('v-flex', [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveDocTypeChange('doctype')
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.handy.startWithUpper(_vm.lDAction)) + " Document Type\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Doc Type",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lDocType.emp_doc_type),
      callback: function($$v) {
        _vm.$set(_vm.lDocType, "emp_doc_type", $$v)
      },
      expression: "lDocType.emp_doc_type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [(_vm.lDocType.emp_doc_type_id) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.saveDocTypeChange('delete-doctype')
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showInsertUpdateDocType = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'upload') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Employee List\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-center primary--text title font-italic"
  }, [_vm._v("\n          In just 4 steps\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "/files/Smartility_Backbone_Employee_Bulk_Upload_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-center primary--text title font-italic"
  }, [_vm._v("\n              Smartility BackBone takes care of rest\n            ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Create Asset List")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0 pr-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          Bulk Upload\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("mdi-check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Tasks uploaded successfully"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("mdi-check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Tasks upload failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Tasks upload partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n              ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n              " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n            ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'upload'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadEmployee($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2 pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-left",
    attrs: {
      "headers": _vm.loadHeadSm,
      "items": _vm.recsLoaded,
      "hide-default-footer": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.vendor_emp_id))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.emp_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.pf_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.uan))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.esi_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.gmc_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.gpa_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.bank_acc_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.bank_ifsc_code))])])]
      }
    }], null, false, 2309268554)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showTimeline),
      callback: function($$v) {
        _vm.showTimeline = $$v
      },
      expression: "showTimeline"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title primary--text"
  }, [_c('div', [_vm._v("Timeline")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTimeline = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pl-0 pr-4 py-3",
    staticStyle: {
      "background-color": "#ffe8d9"
    }
  }, [_c('v-timeline', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.lEmpTimeline), function(timeline, n) {
    return _c('v-timeline-item', {
      key: n,
      class: n === _vm.lEmpTimeline.length - 1 ? 'pb-0' : '',
      attrs: {
        "small": "",
        "id": 'timeline_' + n
      }
    }, [_c('v-card', {
      staticClass: "primary--text"
    }, [_c('v-card-text', {
      staticClass: "pb-0 black--text"
    }, [(timeline.notes !== '') ? _c('div', _vm._l((timeline.timeLineNote), function(note, i) {
      return _c('div', {
        key: i
      }, [(note) ? _c('span', [_vm._v(_vm._s(i + 1 + '. ' + note))]) : _vm._e()])
    }), 0) : _c('div', {
      staticClass: "pb-1"
    }, [_vm._v("\n              " + _vm._s(timeline.notes) + "\n            ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
      staticClass: "caption pa-2"
    }, [_vm._v("\n            Updated by:  "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(timeline.action_by + ' On ' + _vm.handy.formatDate(timeline.action_dt) + ' ' + _vm.handy.getTime12Hrs(timeline.action_dt)))])])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-dbd701ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Employee.vue
// module id = 866
// module chunks = 6